export default class RomaneioConferencia {
  constructor(id = "", produtos = []) {
    this.Id = id
    this.Produtos = produtos
  }
}
